<template>
  <div>
    <v-row class="list__item">
      <v-text-field
        label="Ссылка на фид Интернет Магазина 2 (YML)"
        :color="colors.aqua"
        v-model="websiteYml"
        light
        required
      ></v-text-field>
      <v-btn
        icon
        class="mt-3 ml-2"
        @click="onCopyLink"
        ref="copyWebsiteFeedUrl"
      >
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import ColorPaletteMixin from "@/mixins/ColorPalette";

export default {
  name: "Website2PopupContent",
  props: {
    downloadLinks: Object,
  },
  mixins: [ColorPaletteMixin],
  data() {
    return {
      websiteYml: this.downloadLinks.website2,
    };
  },
  methods: {
    onCopyLink() {
      this.$copyText(this.websiteYml, this.$refs["copyWebsiteFeedUrl"].$el);
    },
  },
};
</script>